import { db, storage } from "firebaseConfig";
import { collection, getDocs, query, where } from "firebase/firestore";
import { storeInfo, storeInfoConverter } from "types/firestoreTypes";
import { ref, uploadString } from "firebase/storage";
import { useLayoutEffect, useRef, useState } from "react";
import DefaultTemplate from "components/templates/DefaultTemplate";
import BackButton from "components/molecules/BackButton";

const Camera = () => {
    const WIDTH = 600;
    const HEIGHT = WIDTH / (4 / 3);
    let interval: NodeJS.Timer | null = null;
    const constraints = useRef({
        audio: false,
        video: true,
    });
    const [rooms, setRooms] = useState<storeInfo[]>([]);
    const [selected, setSelected] = useState("default");
    const [inputted, setInputted] = useState("5");
    const [isShowClearButton, setIsShowClearButton] = useState(false);
    const videoRef = useRef<HTMLVideoElement>(null);

    const canvasRef = useRef<HTMLCanvasElement>(null);
    const getContext = () => {
        if (!canvasRef.current) throw new Error("canvas ref is null");
        const res = canvasRef.current.getContext("2d");
        if (!res) throw new Error("context is null");
        return res;
    };

    const upload = (selected: string) => {
        if (!canvasRef.current) throw new Error("canvas ref is null");
        if (!videoRef.current) throw new Error("video ref is null");
        canvasRef.current.width = WIDTH;
        canvasRef.current.height = HEIGHT;
        getContext().drawImage(videoRef.current, 0, 0, WIDTH, HEIGHT);
        const data = canvasRef.current.toDataURL("image/png");
        // audio.play();
        videoRef.current.pause();
        setTimeout(() => videoRef.current!.play(), 500);

        const r = ref(storage, `congestion/${selected}.png`);
        uploadString(r, data, "data_url").catch((e) => {
            console.error(e);
        });
    };

    useLayoutEffect(() => {
        getDocs(
            query(
                collection(db, "store_info").withConverter(storeInfoConverter),
                where("is_camera", "==", true)
            )
        ).then((res) => {
            setRooms(res.docs.map((val) => val.data()));
        });
    }, []);

    useLayoutEffect(() => {
        if (!videoRef) return;
        navigator.mediaDevices
            .getUserMedia(constraints.current)
            .then((stream) => {
                if (!videoRef.current) throw new Error("video ref is null");
                videoRef.current.srcObject = stream;
                videoRef.current.play();
            });
    }, [constraints]);

    return (
        <DefaultTemplate
            isAdmin={true}
            style={{ textAlign: "center", marginBottom: 0 }}
        >
            <div>
                <BackButton />
            </div>
            <video width={WIDTH} height={HEIGHT} ref={videoRef} />
            <canvas ref={canvasRef} style={{ display: "none" }}></canvas>
            {/* <audio>
                <source src="./camera.mp3" type="audio/mp3" />
            </audio> */}
            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    upload(selected);
                    const intervalMm = Number(inputted);
                    if (!isFinite(intervalMm)) {
                        throw new Error("inputted number is not a number");
                    }
                    if (intervalMm < 1) {
                        alert("撮影間隔は1分以上に設定してください");
                        return;
                    }
                    if (interval) clearInterval(interval);
                    interval = setInterval(
                        () => upload(selected),
                        1000 * 60 * intervalMm
                    );
                    setIsShowClearButton(true);
                }}
            >
                <label>
                    <select
                        name="shop"
                        value={selected}
                        onChange={(e) => setSelected(e.target.value)}
                        required={true}
                    >
                        <option value="default" disabled={true}>
                            選択してください
                        </option>
                        {rooms.map((room) => (
                            <option
                                key={room.store_name}
                                value={room.store_name}
                            >
                                {room.store_name}
                            </option>
                        ))}
                    </select>
                </label>
                <br />
                <label>
                    撮影間隔
                    <input
                        type="number"
                        value={inputted}
                        onChange={(e) => setInputted(e.target.value)}
                        min={1}
                        style={{ width: "2rem" }}
                        required={true}
                    />
                    分
                </label>
                <br />
                <input type="submit" value="撮影開始" />
            </form>
            <div id="clear">
                {isShowClearButton && (
                    <button
                        onClick={() => {
                            interval && clearInterval(interval);
                            setIsShowClearButton(false);
                        }}
                    >
                        停止
                    </button>
                )}
            </div>
        </DefaultTemplate>
    );
};

export default Camera;
